define([
    "./commonScriptModule",
    "text!./nlgScriptEntityEditionParams.html"
], function (controllers, template) {
    "use strict";

    controllers.directive("nlgScriptEntityEditionParams", [function () {
        return {
            template: template,
            scope: {
                entity: "=",
                requiredGenericParams: "=",
                isEnabled: "&?"
            },
            controller: "nlgScriptEntityEditionController"
        };
    }]);
});